import { z } from 'zod';
import { ValidationEntrySeveritySchema } from '../../../../../react-commons/components/ValidationEntrySeverity';
import { IdSchema } from '../../resource-base/baseSchemas';
import { msObject } from '../../resource-base/msObject';

const ImportValidationItemSchema = msObject({
    type: z.string(),
    severity: ValidationEntrySeveritySchema,
});

// export type ImportValidationItem = z.infer<typeof ImportValidationItemSchema>;

const InternalImportValidationResultSchema = msObject({
    propertyValidationEntryResults: ImportValidationItemSchema.array(),
    compoundValidationEntryResults: ImportValidationItemSchema.array(),
    childValidationEntryResults: ImportValidationItemSchema.array(),
    fatal: z.boolean(), // TODO - might not be present with the new jackson settings / use or remove
    maxSeverity: ValidationEntrySeveritySchema,
});

// export type InternalImportValidationResult = z.infer<typeof InternalImportValidationResultSchema>;

const ImportValidationResultSchema = msObject({
    validationResult: InternalImportValidationResultSchema,
    successful: z.boolean(),
});

// export type ImportValidationResult = z.infer<typeof ImportValidationResultSchema>;

export const ImportValidationResourceSchema = msObject({
    projectId: IdSchema.optional(),
    successful: z.boolean(),
    parseSuccessful: z.boolean(),
    exceptionMessage: z.string().optional(),
    erroneousCreationResult: ImportValidationResultSchema.optional(),
    artifactCountsPerValidationSeverity: z.record(z.string(), z.number()).optional(),
});

export type ImportValidationResource = z.infer<typeof ImportValidationResourceSchema>;
